import { render, staticRenderFns } from "./ProratedIcon.vue?vue&type=template&id=e274457e"
import script from "./ProratedIcon.vue?vue&type=script&lang=js"
export * from "./ProratedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports